define('views/pages/checkout/CheckoutStepCartView',['underscore', 'jquery', 'app',
        'views/pages/checkout/CheckoutStepView',
        'InternalLinkView',

        'views/pages/ProductPageView',
        'views/ui/ProductLineView',
        'WidgetCollectionView',
        'views/blocks/CartAdvantagesView',
        'views/blocks/CartVoucherView',
        'views/blocks/CartCagnotteView',
        'views/blocks/CartVoucherPriceView',
        'views/blocks/CartMinimumShippingPriceView',
        'views/blocks/checkout/ProductCheckoutDialogView',
        'template!cart',
        'views/blocks/CartExtraPriceView',
        'views/blocks/CartProductOfferedView',
        'template!blocks/cart/product-list',
    ],
    function (_, $, app,
              CheckoutStepView,
              InternalLinkView,

              ProductPageView,
              ProductLineView,
              WidgetCollectionView,
              CartAdvantagesView,
              CartVoucherView,
              CartCagnotteView,
              CartVoucherPriceView,
              CartMinimumShippingPriceView,
              ProductCheckoutDialogView,
              cartTemplate,
              CartExtraPriceView,
              CartProductOfferedView,
              CartProductListTemplate
              ) {

        var view, cart, checkoutModel, cartAdvantagesWidgetView;

        return CheckoutStepView.extend({

            name:'cart',
            events: {
                'click .btn--use-advantages':'clickUseAdvantages',
            },

            beforeInitialize: function (model) {
                cart = app.getCart();
                view = this;
                checkoutModel = model;
                view.listenTo(cart.getProducts(), 'add', view.onAddProduct);
                view.listenTo(cart, 'change:total_price_ttc change:cagnotte', view.onChangePrice);
                view.listenTo(cart, 'empty', view.render);
                view.listenTo(app,'productLineClick',view.clickProduct);
                view.listenTo(app.getCustomer(),'change:usableAdvantagesOnCart login logout',view.onChangeAdvantages);
            },

            render:function(){
                view.$el.html(cartTemplate({
                    cart:cart,
                    checkout:checkoutModel
                }));
                cart.checkProducts(false);

                view.attachViews(ProductLineView.initializeProductLinesOfView(view));
                view.appendView(CartAdvantagesView,'.cart-advantages');
                view.appendView(CartCagnotteView, '.cart-cagnotte', {checkoutModel: checkoutModel});
                view.appendView(CartVoucherView,'.cart-voucher',{checkout:true});
                view.appendView(CartMinimumShippingPriceView,'.minimum-shipping-price');
                view.appendView(CartExtraPriceView,'.cart-extra-price');
                view.appendView(CartVoucherPriceView,'.cart-voucher-total');
                view.appendView(CartProductOfferedView,'.product-offered-like');

                cartAdvantagesWidgetView = new WidgetCollectionView('cart_advantages');
                view.$('.cart-advantages__widgets').append(cartAdvantagesWidgetView.el);
                view.attachView(cartAdvantagesWidgetView);
                view.onChangeAdvantages();
            },

            onAddProduct:function(e){
                //
                view.$('.checkout-opc__product-list').html(CartProductListTemplate(checkoutModel.allCartProductListOptions()));
                view.attachViews(ProductLineView.initializeProductLinesOfView(view));
            },

            addProduct: function () {
                view.render();
            },

            onChangePrice:function(){
                this.$('.cart-total-price').text(checkoutModel.formatPriceTotal());
            },

            clickUseAdvantages:function(){
                var message = app.t('merci de vous connecter pour pouvoir utiliser vos avantages','Checkout');
                checkoutModel.requireAuthentification(message);
            },

            onChangeAdvantages:function(){
                if(cartAdvantagesWidgetView) cartAdvantagesWidgetView.updateCollection();
            },

            clickProduct:function(cartProduct){
                if(app.isMobile()){
                    new ProductCheckoutDialogView({checkoutModel:checkoutModel,cartProduct:cartProduct});
                }else{
                    var options = {
                        id_product:cartProduct.getProduct().id,
                        cartProduct:cartProduct
                    };
                    app.displayModal(new ProductPageView(options));
                }
            }

        });
    });

